import React, { useState, useEffect } from 'react'
import firebase from '../firebase'

export default function AuthWidget () {
  const [user, setUser] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    return firebase.auth().onAuthStateChanged(setUser)
  }, [])

  const signIn = () => {
    setError(null)
    firebase.auth()
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .catch((e) => setError(e.message))
  }

  const signOut = () => firebase.auth().signOut()

  return (
    <div className="auth-widget">
      {user ? (
        <>
          <span>Signed in as {user.email}</span>
          <button onClick={signOut}>Sign Out</button>
        </>
      ) : (
        <button onClick={signIn}>Sign in with Google</button>
      )}
      {error && <div className="auth-error">{error}</div>}
    </div>
  )
}
